import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * The v1 sheet editor's addresses after the switch-over (issue 934, plan
 * §3.10): `/authoring/:slug/sheet/:key` and a homebrew's whole copy at
 * `/authoring/homebrew/:id/sheet/:key/replace` open the builder, with the
 * query string kept, so a bookmark or an old link still lands on the sheet.
 * A homebrew's FRAGMENT editor (`/authoring/homebrew/:id/sheet/:key`) is not
 * redirected: the builder edits whole sheets, and a fragment adds to one.
 */
export default function SheetBuilderRedirect({ layer = false }) {
  const { slug, id, key } = useParams();
  const { search } = useLocation();
  const base = layer
    ? `/authoring/homebrew/${encodeURIComponent(id)}/sheet/${encodeURIComponent(key)}/build`
    : `/authoring/${encodeURIComponent(slug)}/sheet/${encodeURIComponent(key)}/build`;
  return <Navigate to={`${base}${search || ''}`} replace />;
}

SheetBuilderRedirect.propTypes = { layer: PropTypes.bool };
